// Mobile carousel: auto-scroll + dot indicators for sections opted into
// "Carousel on mobile" (.section-content--mobile-carousel). Desktop untouched.
(function () {
  const MQ = window.matchMedia('(max-width: 749px)');
  const SEL = '.section-content--mobile-carousel';
  const INTERVAL = 3500;
  const RESUME_DELAY = 5000;

  function init(root) {
    (root || document).querySelectorAll(SEL).forEach(setup);
  }

  function setup(track) {
    if (track.__mcInit) return;
    const items = Array.from(track.children);
    if (items.length < 2) return;
    track.__mcInit = true;

    const dots = document.createElement('div');
    dots.className = 'mobile-carousel-dots';
    items.forEach(function (_, i) {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Slide ' + (i + 1));
      b.addEventListener('click', function () { goTo(i); userPause(); });
      dots.appendChild(b);
    });
    track.insertAdjacentElement('afterend', dots);
    const dotBtns = Array.from(dots.children);

    let index = 0, timer = null, resume = null, raf = null;

    function itemLeft(i) {
      return items[i].getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    }
    function goTo(i) {
      index = (i + items.length) % items.length;
      track.scrollTo({ left: itemLeft(index), behavior: 'smooth' });
    }
    function next() { goTo(index + 1); }
    function currentIndex() {
      let best = 0, bd = Infinity, base = track.getBoundingClientRect().left;
      items.forEach(function (c, i) {
        const d = Math.abs(c.getBoundingClientRect().left - base);
        if (d < bd) { bd = d; best = i; }
      });
      return best;
    }
    function updateDots() {
      const cur = currentIndex();
      index = cur;
      dotBtns.forEach(function (b, i) { b.setAttribute('aria-current', i === cur ? 'true' : 'false'); });
    }

    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; updateDots(); });
    }, { passive: true });

    function start() { stop(); if (MQ.matches) timer = setInterval(next, INTERVAL); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function userPause() { stop(); clearTimeout(resume); resume = setTimeout(start, RESUME_DELAY); }

    ['pointerdown', 'touchstart', 'mouseenter'].forEach(function (ev) {
      track.addEventListener(ev, userPause, { passive: true });
    });

    function apply() {
      if (MQ.matches) { updateDots(); start(); }
      else { stop(); track.scrollTo({ left: 0 }); }
    }
    if (MQ.addEventListener) MQ.addEventListener('change', apply); else MQ.addListener(apply);
    apply();
    updateDots();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
